import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useStaticQuery, graphql } from "gatsby"

import ContentModule from "../../modules/content_module";
import NewsletterForm from "../forms/newsletter-form";

import "./Subscribe.scss";
const Subscribe = () => {

    const data = useStaticQuery(graphql`
    query NewsletterQuery{
        glstrapi {
            siteConfig {
                news_letter {
                    title
                    form_bottom_content
                    content
                }
            }

        }
    }`)

    var site_config = data.glstrapi.siteConfig;

    return (
        <React.Fragment>
            <section className="subscribe">
                <Container>
                    <Row>
                        <Col>
                            <div className="form-wrapper">
                                <h3>{site_config?.news_letter?.title}</h3>

                                {site_config?.news_letter?.content && <ContentModule Content={site_config.news_letter?.content} />}

                                    <div className="form-info">
                                        <NewsletterForm />
                                    </div>
                                    <span className="sm-text">
                                        {site_config?.news_letter?.form_bottom_content && <ContentModule Content={site_config?.news_letter?.form_bottom_content} />}
                                    </span>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Subscribe;
